import { moduleName } from '../constants';

const moduleSel = state => state[moduleName];

export const ratingModalOpenSel = state => moduleSel(state).ratingModalOpen;
export const bugModalOpenSel = state => moduleSel(state).bugModalOpen;
export const featureModalOpenSel = state => moduleSel(state).featureModalOpen;
